import React from 'react';
import Icon from '../common/Icon';

const ContainerPermission = ({
  role,
  modelName,
  updateRole,
  destroyRole,
  includeUserName,
}) => {
  return (
    <>
      {includeUserName && (
        <div className='name'>
          {role[modelName].name}&nbsp;
          <i
            className={
              'fa-solid fa-' + (modelName == 'user' ? 'home' : 'globe')
            }
            aria-hidden='true'
          ></i>
        </div>
      )}

      <div className='permissions'>
        <input
          type='radio'
          value='0'
          id={role.id + '-read'}
          name={role.id}
          checked={role.role == 'read'}
          onChange={() => updateRole(role.id, 0)}
        />
        <label htmlFor={role.id + '-read'}>Read:</label>

        <input
          type='radio'
          value='1'
          id={role.id + '-write'}
          name={role.id}
          checked={role.role == 'write'}
          onChange={() => updateRole(role.id, 1)}
        />
        <label htmlFor={role.id + '-write'}>Write:</label>

        {/* <input
          type='radio'
          value='2'
          id={role.id + '-manage'}
          name={role.id}
          checked={role.role == 'manage'}
          onChange={() => updateRole(role.id, 2)}
        />
        <label htmlFor={role.id + '-manage'}>Manage:</label> */}
      </div>

      <div className='controls'>
        <Icon icon='trash' onClick={() => destroyRole(role.id)} />
      </div>
    </>
  );
};

export default ContainerPermission;
